import { Suspense } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import Loader from "./components/common/UI/Loader/Loader";
import { lazyPage } from "./lib/lazyPage";
import Layout from "./components/compound/Layout";
const Dashboard = lazyPage(() => import("./components/compound/Dashboard"));
// import Clients from "./components/compound/Clients";
// import CaseFiles from "./components/compound/CaseFiles";
const Requisitions = lazyPage(() => import("./components/compound/Requisitions"));
// import Tasks from "./components/compound/Tasks";
const ClvDatabase = lazyPage(() => import("./components/compound/ClvDatabase"));
const TravelOrder = lazyPage(() => import("./components/compound/TravelOrder"));
const Members = lazyPage(() => import("./components/Membership/Members/Members"));
const MembersActivities = lazyPage(() => import("./components/Membership/MembersActivities/MembersActivities"));
const Allocations = lazyPage(() => import("./components/Membership/Allocations/Allocations"));
const Notifications = lazyPage(() => import("./components/Membership/Notifications/Notifications"));
const Approvals = lazyPage(() => import("./components/Membership/Approvals/Approvals"));
const HRApprovals = lazyPage(() => import("./components/HumanResource/Approvals/Approvals"));
const PayRoll = lazyPage(() => import("./components/HumanResource/PayRoll/PayRoll"));
const LeaveManagement = lazyPage(() => import("./components/HumanResource/LeaveManagement/LeaveManagement"));
const EmployeeContract = lazyPage(() => import("./components/HumanResource/EmployeeContract/EmployeeContract"));
const FidaAssets = lazyPage(() => import("./components/HumanResource/FidaAssets/FidaAssets"));
const Reports = lazyPage(() => import("./components/HumanResource/Reports/Reports"));
const Tracker = lazyPage(() => import("./components/compound/Tracker"));
const AccountSettings = lazyPage(() => import("./components/compound/AccountSettings"));
const FleetDatabase = lazyPage(() => import("./components/fleetManager/FleetDatabase"));
const Procurements = lazyPage(() => import("./components/procurement/Procurements"));
const FidaApprovals = lazyPage(() => import("./components/HumanResource/FidaApprovals/FidaApprovals"));
const Tasks = lazyPage(() => import("./components/Tasks/Tasks"));
const Clients = lazyPage(() => import("./components/LegalAid/Clients/Clients"));
const CLVs = lazyPage(() => import("./components/LegalAid/CLVs/CLVs"));
const ClvCaseFiles = lazyPage(() => import("./components/LegalAid/ClvCaseFiles/ClvCaseFiles"));
const CaseFiles = lazyPage(() => import("./components/LegalAid/CaseFIles/CaseFiles"));
const ProjectFiles = lazyPage(() => import("./components/LegalAid/ProjectFiles/ProjectFiles"));
const FidaProjects = lazyPage(() => import("./components/ME/FidaProjects/FidaProjects"));
const FidaProjectFiles = lazyPage(() => import("./components/ME/FidaProjects/FidaProjectFiles/FidaProjectFiles"));
const FidaDatabases = lazyPage(() => import("./components/ME/FidaDatabases/FidaDatabases"));
const DatabaseOpen = lazyPage(() => import("./components/ME/FidaDatabases/DatabaseOpen"));
const ClientFiles = lazyPage(() => import("./components/Counsellor/ClientFiles/ClientFiles"));
const ITProducts = lazyPage(() => import("./components/itDepartment/Products/ITProducts"));
const ITServices = lazyPage(() => import("./components/itDepartment/Services/ITServices"));
const ITComplaints = lazyPage(() => import("./components/itDepartment/Complaints/ITComplaints"));
const Employees = lazyPage(() => import("./components/HumanResource/EmployeeContract/Employees"));
const EventAttendence = lazyPage(() => import("./components/dashboard/EventsAttendence/EventAttendence"));
const ReportFiles = lazyPage(() => import("./components/HumanResource/Reports/ReportFiles/ReportFiles"));
const SummaryDetails = lazyPage(() => import("./components/dashboard/SummaryDetails/SummaryDetails"));
const LegalOfficer = lazyPage(() => import("./components/CourtProcessServer/LegalOfficer/LegalOfficer"));
const ReportSummaryDetails = lazyPage(() => import("./components/HumanResource/Reports/ReportSummary/ReportSummary"));
const ProjectFilesDocuments = lazyPage(() => import("./components/LegalAid/ProjectFiles/ProjectDocuments/ProjectFilesDocuments"));
const FileSummary = lazyPage(() => import("./components/LegalAid/ProjectFiles/ProjectFilesTable/FileSummary"));
const FidaProjectFilesDocuments = lazyPage(() => import("./components/ME/FidaProjects/FidaProjectFiles/FidaProjectFilesDocuments"));
const FidaDocumentSummary = lazyPage(() => import("./components/ME/FidaProjects/FidaProjectFiles/FidaDocumentSummary"));
const EditRequisition = lazyPage(() => import("./components/dashboard/SummaryDetails/ApprovalFlows/EditRequisition"));
const DepartmentManagement = lazyPage(() => import("./components/dashboard/LeaveTracker/DepartmentManagement"));

const View = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            {/* Each page's code downloads the first time it is opened. */}
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </Layout>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="leave-advance-tracker" element={<Tracker />} />
        <Route path="application-summary" element={<SummaryDetails />} />
        <Route path="events-attendance" element={<EventAttendence />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients-files" element={<ClientFiles />} />
        <Route path="clvs" element={<CLVs />} />
        <Route path="account-settings" element={<AccountSettings />} />
        <Route path="case-files" element={<CaseFiles />} />
        <Route path="legal-officer" element={<LegalOfficer />} />
        <Route path="departments" element={<DepartmentManagement />} />
        <Route path="project-files" element={<ProjectFiles />} />
        <Route
          path="project-files/documents/:folderName/:id"
          element={<ProjectFilesDocuments />}
        />
        <Route path="project-files/documents/:id" element={<FileSummary />} />
        <Route path="clv-case-files" element={<ClvCaseFiles />} />
        <Route path="clv-database" element={<ClvDatabase />} />
        <Route path="requisitions" element={<Requisitions />} />
        <Route
          path="requisitions/:reqName"
          element={<SummaryDetails type="requisition" />}
        />
        <Route path="travel-order" element={<TravelOrder />} />
        <Route path="/edit-requisition/:reqName" element={<EditRequisition />} />
        <Route
          path="travel-order/:travelName"
          element={<SummaryDetails type="travel" />}
        />
        <Route path="members" element={<Members />} />
        <Route path="members-activities" element={<MembersActivities />} />
        <Route path="allocations" element={<Allocations />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="approvals" element={<Approvals />} />
        <Route path="fida-iims-approvals" element={<FidaApprovals />} />
        <Route path="hr-approvals" element={<HRApprovals />} />
        <Route path="payroll" element={<PayRoll />} />
        <Route path="leave-management" element={<LeaveManagement />} />
        <Route path="employees" element={<Employees />} />
        <Route path="contracts" element={<EmployeeContract />} />
        <Route path="fida-assets" element={<FidaAssets />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/:reportFolderName" element={<ReportFiles />} />
        <Route
          path="reports/reportFolder/:id"
          element={<ReportSummaryDetails />}
        />
        <Route path="it-products" element={<ITProducts />} />
        <Route path="it-services" element={<ITServices />} />
        <Route path="it-complaints" element={<ITComplaints />} />
        <Route path="fleet-database" element={<FleetDatabase />} />
        <Route path="procurements" element={<Procurements />} />
        <Route path="fida-databases" element={<FidaDatabases />} />
        <Route path="fida-databases/:dbName" element={<DatabaseOpen />} />
        <Route path="fida-projects" element={<FidaProjects />} />
        <Route
          path="fida-projects/:folderName/:id"
          element={<FidaProjectFiles />}
        />
        <Route
          path="fida-project-files/documents/:folderName/:id"
          element={<FidaProjectFilesDocuments />}
        />
        <Route
          path="fida-project-files/documents/:id"
          element={<FidaDocumentSummary />}
        />
      </Route>
    </Routes>
  );
};

export default View;
